export function getGrades() {
  const grades = [];
  let i;
  // for (i=1; i<14; i++){
  for (i = 9; i < 14; i++) {
    grades.push({ id: i, name: `${i}ª classe` });
  }
  grades.push({ id: 19, name: "Ensino médio concluído" });

  for (i = 21; i < 27; i++) {
    grades.push({ id: i, name: `${i % 20}º ano` });
  }

  grades.push({ id: 29, name: "Licenciatura" });
  grades.push({ id: 30, name: "Mestrado" });
  grades.push({ id: 40, name: "Doutoramento" });
  grades.push({ id: 0, name: "Outro" });
  return grades;

  // return [
  //     { id: 1, name: "Primeira classe" },
  //     { id: 2, name: "Segunda classe" },
  //     { id: 3, name: "Terceira classe" },
  //     { id: 4, name: "Quarta classe" },
  //     { id: 5, name: "Quinta classe" },
  //     { id: 6, name: "Sexta classe" },
  //     { id: 7, name: "Sétima classe" },
  //     { id: 8, name: "Oitava classe" },
  //     { id: 9, name: "Nona classe" },
  //     { id: 10, name: "Décima classe" },
  //     { id: 11, name: "Décima-primeira classe" },
  //     { id: 12, name: "Décima-Segunda classe" },
  //     { id: 13, name: "Décima-terceira classe" },
  //     { id: 19, name: "Ensino Médio Concluído" },
  //     { id: 21, name: "Primeiro ano" },
  //     { id: 22, name: "Segundo ano" },
  //     { id: 23, name: "Terceiro ano" },
  //     { id: 24, name: "Quarto ano" },
  //     { id: 25, name: "Quinto ano" },
  //     { id: 26, name: "Sexto ano" },
  //     { id: 29, name: "Licenciado"},
  //     { id: 30, name: "Mestrado" },
  //     { id: 40, name: "Doutoramento" }
  // ];
}
